import TriggeredHookContextDecorator from "../../../App/Compositions/TriggeredHookContextDecorator";
import useResilientCreateMedicalNonCanLeadResult from "../Hooks/useResilientCreateMedicalNonCanLeadResult";

/** Decorate the {@link useResilientCreateMedicalNonCanLeadResult} hook, providing context-aware parameters. */
const ComposedUseCreateMedicalNonCanLeadResult = TriggeredHookContextDecorator(
  useResilientCreateMedicalNonCanLeadResult,
  ({ leadIdCState, customerCState, disqualifyingReasonsCState }) => ({
    leadId: leadIdCState,
    customerId: customerCState.id,
    customerOpportunityId: customerCState.opportunity.id,
    disqualifyingReasons: disqualifyingReasonsCState || []
  })
);

export default ComposedUseCreateMedicalNonCanLeadResult;
